import { z } from 'zod';
export const RegisterSchema = z.object({
  name: z.string().min(2, 'Tên phải có ít nhất 2 ký tự'),
  email: z.string().email('Email không hợp lệ'),
  password: z.string().min(8, 'Mật khẩu phải có ít nhất 8 ký tự'),
  confirm_password: z.string(),
  tel: z.string().min(10, 'Số điện thoại phải có ít nhất 10 số'),
}).refine((data) => data.password === data.confirm_password, {
  message: "Mật khẩu xác nhận không khớp",
  path: ["confirm_password"],
});
export type RegisterBodyType = z.infer<typeof RegisterSchema>;